export default function bookingCompletedInfobox() {
    return {
        restrict: "E",
        scope: {
            payment: "=",
        },
        template: require("./template.html"),
        controller: function () {},
    };
}
